import { render, staticRenderFns } from "./DetailsPhoneCard.vue?vue&type=template&id=7f01ed96&scoped=true"
import script from "./DetailsPhoneCard.vue?vue&type=script&lang=ts"
export * from "./DetailsPhoneCard.vue?vue&type=script&lang=ts"
import style0 from "./DetailsPhoneCard.vue?vue&type=style&index=0&id=7f01ed96&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f01ed96",
  null
  
)

export default component.exports